import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'

const InteractorMasterCategoryMainView = () => {
  const { t } = useTranslation()

  const categoryMainView = useCallback(
    (payload, callback, loading) => {
      ApiService.jsonRequest('/master-category/main-view', payload, response => {
        if (response.status_code === 200) {
          callback(response.data)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: 1500,
            redirect: '/master/category-main/manage',
          })
        }
        loading(false)
      })
    },
    [t],
  )

  return { categoryMainView }
}

export default InteractorMasterCategoryMainView
